import { wasErrorShownToUser } from '#features/api/utils/shownErrors';

type SentryEventLike = {
  level?: string;
  tags?: Record<string, unknown>;
  exception?: { values?: { mechanism?: { handled?: boolean } }[] };
};

/**
 * Понижает событие, отказ которого человек уже увидел (см. `shownErrors`).
 *
 * `mutateAsync` отклоняет промис даже при живом `onError`, поэтому обработанный отказ приходит
 * сюда через `unhandledrejection` — уровнем error и с `handled: false`, неотличимо от падения
 * приложения. Событие остаётся: отбитый шлюзом запрос обычно означает баг фронта, и терять такой
 * сигнал нельзя. Меняется только то, чем оно притворялось.
 */
export const demoteShownErrorEvent = <TEvent extends SentryEventLike>(
  event: TEvent,
  hint?: { originalException?: unknown }
): TEvent => {
  if (!wasErrorShownToUser(hint?.originalException)) {
    return event;
  }

  event.level = 'warning';
  event.tags = { ...event.tags, shown_to_user: true };

  for (const value of event.exception?.values ?? []) {
    if (value.mechanism) {
      value.mechanism.handled = true;
    }
  }

  return event;
};
